import { Dialog, DialogTitle } from '@mui/material';
import Box from '@mui/material/Box';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { Button } from '../../../../../shared/components/button/Button';
import * as Icon from '@mui/icons-material';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import { Input } from '../../../../../shared/components/Input';
import { InputMoney } from '../../../../../shared/components/InputMoney';
import {
  InputSelect,
  Item,
} from '../../../../../shared/components/InputSelect';

interface ModalServiceSelectProps {
  handleCloseModalSearchProduct: () => void;
  modalSearchProduct: boolean;
  productIsEditing: boolean;
  modalSearchTitle: string;
  productOptions: SelectAutoCompleteOptions[];
  activeProductSelected: any;
  handleSearchProduct: (value: string, type: string) => void;
  handleAutoCompleteSelectedService: (value: SelectAutoCompleteOptions) => void;
  formService: any;
  cfopOptions: Item[];
  codigoTributarioOptions: SelectAutoCompleteOptions[];
  activeCodigoTributarioSelected: any;
  handleSearchCodigoTributario: (value: string) => void;
  handleAutoCompleteSelectedCodigoTributario: (
    value: SelectAutoCompleteOptions
  ) => void;
  codigoNBSOptions: SelectAutoCompleteOptions[];
  activeCodigoNBSSelected: any;
  handleSearchCodigoNBS: (value: string) => void;
  handleAutoCompleteSelectedCodigoNBS: (
    value: SelectAutoCompleteOptions
  ) => void;
  showCreateProduct: boolean;
  handleCreateProduct: () => void;
}

export const ModalServiceSelect = ({
  handleCloseModalSearchProduct,
  modalSearchProduct,
  modalSearchTitle,
  productOptions,
  handleSearchProduct,
  handleAutoCompleteSelectedService,
  formService,
  activeProductSelected,
  productIsEditing,
  activeCodigoTributarioSelected,
  handleSearchCodigoTributario,
  handleAutoCompleteSelectedCodigoTributario,
  codigoTributarioOptions,
  activeCodigoNBSSelected,
  handleSearchCodigoNBS,
  handleAutoCompleteSelectedCodigoNBS,
  codigoNBSOptions,
  cfopOptions,
  showCreateProduct,
  handleCreateProduct,
}: ModalServiceSelectProps) => {
  const { handleBlur, handleChange, touched, errors, values, handleSubmit } =
    formService;

  return (
    <Dialog
      onClose={() => handleCloseModalSearchProduct()}
      open={modalSearchProduct}
      fullWidth={true}
      maxWidth={'lg'}
    >
      <DialogTitle className='!font-bold !text-md'>
        {modalSearchTitle}
      </DialogTitle>
      <form className={'px-6 pb-4 pt-2 w-full'} onSubmit={handleSubmit}>
        <Box className={'grid grid-cols-12 pt-4 gap-6'}>
          <SelectAutoCompleteComponent
            disabled={productIsEditing}
            label={'Produto *'}
            value={activeProductSelected?.prod_descricao ?? ''}
            className={'col-span-6'}
            name={'search'}
            options={productOptions}
            handleSearch={(value: string) =>
              handleSearchProduct(value, 'servico')
            }
            onSelectValue={handleAutoCompleteSelectedService}
          />
          <InputSelect
            label='Grupo Tributário'
            name='grupo_tributario'
            items={cfopOptions}
            className={'col-span-6'}
            handleChange={handleChange}
            helperText={errors?.grupo_tributario ? errors?.grupo_tributario : ''}
            error={!!errors?.grupo_tributario}
            value={values?.grupo_tributario ?? ''}
          />
          <SelectAutoCompleteComponent
            label={'Código Tributário'}
            value={activeCodigoTributarioSelected?.cnt_descricao ?? ''}
            className={'col-span-6'}
            name={'search'}
            options={codigoTributarioOptions}
            handleSearch={(value: string) =>
              handleSearchCodigoTributario(value)
            }
            onSelectValue={handleAutoCompleteSelectedCodigoTributario}
          />
          <SelectAutoCompleteComponent
            label={'Código NBS'}
            value={activeCodigoNBSSelected?.cnbs_descricao ?? ''}
            className={'col-span-6'}
            name={'search'}
            options={codigoNBSOptions}
            handleSearch={(value: string) => handleSearchCodigoNBS(value)}
            onSelectValue={handleAutoCompleteSelectedCodigoNBS}
          />
          <Input
            label='Quantidade *'
            name='quantidade'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.quantidade && errors?.quantidade
                ? errors?.quantidade
                : ''
            }
            hasError={!!(touched?.quantidade && errors?.quantidade)}
            value={values?.quantidade ?? ''}
          />
          <InputMoney
            label={'Valor *'}
            className={'col-span-6'}
            name={'value'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched?.value && errors?.value ? errors?.value : ''}
            hasError={!!(touched?.value && errors?.value)}
            value={values?.value ?? ''}
          />
          <InputMoney
            label={'Desconto'}
            className={'col-span-6'}
            name={'desconto'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.desconto && errors?.desconto ? errors?.desconto : ''
            }
            hasError={!!(touched?.desconto && errors?.desconto)}
            value={values?.desconto ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total'}
            className={'col-span-6'}
            name={'total'}
            value={values?.total ?? ''}
          />
          <Input
            label='Descrição Outras Retenções'
            name='desc_outras_retencoes'
            className={'col-span-6'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.desc_outras_retencoes && errors?.desc_outras_retencoes
                ? errors?.desc_outras_retencoes
                : ''
            }
            hasError={
              !!(
                touched?.desc_outras_retencoes && errors?.desc_outras_retencoes
              )
            }
            value={values?.desc_outras_retencoes ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Outras Retenções'}
            className={'col-span-6'}
            name={'outras_retencoes'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.outras_retencoes && errors?.outras_retencoes
                ? errors?.outras_retencoes
                : ''
            }
            hasError={!!(touched?.outras_retencoes && errors?.outras_retencoes)}
            value={values?.outras_retencoes ?? ''}
          />
          <Input
            label='Discriminação'
            name='discriminacao'
            className={'col-span-12'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.discriminacao && errors?.discriminacao
                ? errors?.discriminacao
                : ''
            }
            hasError={!!(touched?.discriminacao && errors?.discriminacao)}
            value={values?.discriminacao ?? ''}
          />
        </Box>

        <Box className={'px-6 pt-8 w-full flex justify-end gap-4'}>
          <Button
            variant='secondary'
            className={'!px-6'}
            onClick={() => handleCloseModalSearchProduct()}
            iconStart={<Icon.Close />}
            title={'Cancelar'}
          />
          {showCreateProduct && (
            <Button
              variant='primary'
              className={'!px-6'}
              onClick={handleCreateProduct}
              iconStart={<Icon.Create />}
              title={'Criar'}
            />
          )}
          {/* Codigo Tributario e Codigo NBS deixaram de ser obrigatorios (pedido do
              cliente): o unico campo que ainda travava o Confirmar e o Produto. */}
          <Button
            disabled={!activeProductSelected?.prod_id}
            variant='primary'
            className={'!px-6'}
            type={'submit'}
            iconStart={<Icon.Check />}
            title={'Confirmar'}
          />
        </Box>
      </form>
    </Dialog>
  );
};
